export default __webpack_public_path__ + "static/media/gallery-wip-emitter-tip_03.e9c70f21.jpg";